import clsx from "clsx";
import { useTranslate } from "@made-people/grease-translations";

export const ProductDeliveryStatus = ({
  status,
  isImmediateDelivery,
  discontinued,
  inStock,
}: {
  status: string;
  discontinued: boolean;
  inStock: boolean;
  isImmediateDelivery: boolean;
}) => {
  const translate = useTranslate();
  const isDiscontinued = discontinued && !inStock;
  const dotClass = isDiscontinued
    ? "bg-system-unavailable"
    : isImmediateDelivery
      ? "bg-system-in-stock"
      : "bg-system-pending";

  return (
    <div className="flex items-start gap-component-spacing-2xs text-body-sm text-black min-h-5">
      <span
        className={clsx(
          "mt-[calc((1lh-var(--spacing-component-spacing-2xs))/2)] size-component-spacing-2xs shrink-0 rounded-full",
          dotClass,
        )}
        aria-hidden
      />
      <span>
        {isDiscontinued
          ? translate("In_Stock_Message_Product_Is_Discontinued")
          : status}
      </span>
    </div>
  );
};
